export const getNumberOfDigitsAfterDecimalPoint = (value: string, decimalSeparator: string): number => {
  let result = 0;

  const splitAfterSeparator = value.split(decimalSeparator)[1];
  result = splitAfterSeparator ? splitAfterSeparator.length : 0;

  return result;
};
